/** The service page's behavior half: reads the page's service, the studio's name and, on a custom site, its links. Draws nothing. */
import { useParams } from 'react-router-dom';

import { SiteFetchError, useSiteService, useSiteStudio } from '../../api/site';
import { usePieceOptions, type PieceInput, type PieceRuntime } from '../../contract/runtime';
import { readSite } from '../../site';
import { contract, type ServicePageActions, type ServicePageEvents, type ServicePageState } from './contract';

export type ServicePageRuntime = PieceRuntime<typeof contract, ServicePageState, ServicePageActions>;

export interface ServicePageInput extends PieceInput<ServicePageEvents> {
  /** The service to show; defaults to the page address's service. */
  readonly serviceId?: string;
}

const NO_ACTIONS: ServicePageActions = {};

export function useServicePage(input: ServicePageInput = {}): ServicePageRuntime {
  const options = usePieceOptions(contract, input.options);
  const params = useParams<{ serviceId?: string }>();
  const query = useSiteService(input.serviceId ?? params.serviceId);
  const studio = useSiteStudio();

  const status: ServicePageState['status'] = query.isError
    ? query.error instanceof SiteFetchError && query.error.status >= 400 && query.error.status < 500
      ? 'not-found'
      : 'error'
    : query.isPending
      ? 'loading'
      : 'ready';

  return {
    state: { status, service: query.data ?? null, studioName: studio.data?.name ?? null, siteLinks: readSite()?.links ?? null },
    actions: NO_ACTIONS,
    options,
  };
}
